import { API } from 'aws-amplify';
import { useMemo } from 'react';
import { USE_CHATBOT_LOCAL_FETCH_STRATEGY } from '../../../config/configuration';
import { useChatContext } from '../context';

// eslint-disable-next-line no-unused-vars
const fetchBaseLocal = {
  get: async (url, headers) => fetch(url, { method: 'GET', headers }),
  post: async (url, body, headers) => fetch(url, { method: 'POST', body, headers }),
  put: async (url, body, headers) => fetch(url, { method: 'PUT', body, headers }),
};

const lambdaName = 'ChatAPI';

const toAPIGatewayFormat = ({
  method, url, body, headers,
}) => ({
  body: {
    resource: url,
    path: url,
    httpMethod: method,
    requestContext: {
      resourcePath: url,
      httpMethod: method,
    },
    headers,
    body,
  // isBase64Encoded: false,
  },
});

const toResponseFormat = ({ body, headers, statusCode }) => new Response(body, {
  headers,
  status: statusCode,
});

// eslint-disable-next-line no-unused-vars
const fetchAWSLambdaBase = {
  get: async (url, headers) => API.post(lambdaName, '/', toAPIGatewayFormat({
    url,
    headers,
    method: 'GET',
  })).then(toResponseFormat),
  post: async (url, body, headers) => API.post(lambdaName, '/', toAPIGatewayFormat({
    url, body, headers, method: 'POST',
  })).then(toResponseFormat),
  put: async (url, body, headers) => API.post(lambdaName, '/', toAPIGatewayFormat({
    url, body, headers, method: 'PUT',
  })).then(toResponseFormat),
};

export const useFetch = () => {
  let fetchBase;
  let backendUrl;
  if (!USE_CHATBOT_LOCAL_FETCH_STRATEGY) {
    fetchBase = fetchAWSLambdaBase;
    backendUrl = '';
  } else {
    fetchBase = fetchBaseLocal;
    backendUrl = 'http://localhost:5050';
  }

  const {
    requestId,
    clientId,
  } = useChatContext();

  const fetchInstance = useMemo(() => ({
    get: async (url, headers) => fetchBase.get(`${backendUrl}${url}`, {
      ...headers,
      'request-id': requestId,
      'client-id': clientId,
    }),
    post: async (url, body, headers) => fetchBase.post(`${backendUrl}${url}`, body, {
      ...headers,
      'request-id': requestId,
      'client-id': clientId,
    }),
    put: async (url, body, headers) => fetchBase.put(`${backendUrl}${url}`, body, {
      ...headers,
      'request-id': requestId,
      'client-id': clientId,
    }),
  }), [backendUrl, clientId, requestId, fetchBase]);

  return { fetchInstance };
};

export default useFetch;
